import Vue from "vue";
import { getAuth, onAuthStateChanged } from "firebase/auth";

/** Reactive Firebase auth user; subscribe with initAuthStateListener() from main.js. */
export const authState = Vue.observable({
  user: null,
  ready: false,
});

let listenerStarted = false;

export function initAuthStateListener() {
  if (listenerStarted) return;
  listenerStarted = true;
  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    authState.user = user;
    authState.ready = true;
  });
}

export function isLoggedIn() {
  return authState.user != null;
}
